// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerCompanyStatsModel } from '~/modules/manager/company/stats/stats.model';

export class ManagerCompanyStatsDataClient extends AbstractDataClient<ManagerCompanyStatsModel> {
  constructor() {
    super(new ManagerCompanyStatsModel());
  }
}
